var _defs, _rect, _rect2, _path, _g, _path2, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OBJECTS",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #afbdc7;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        opacity: .3;\n      }\n\n      .cls-4 {\n        fill: #d6dee2;\n      }\n\n      .cls-5 {\n        fill: #1e96ff;\n      }\n\n      .cls-6 {\n        fill: #0078e1;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    y: 10.73,
    width: 2.12,
    height: 2.88
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 0,
    y: 9.62,
    width: 17.88,
    height: 2.23,
    rx: 1.11,
    ry: 1.11
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M0,11.84h18.99c.55,0,1.01.45,1.01,1.01v6.15c0,.55-.45,1.01-1.01,1.01H1.01C.45,20,0,19.55,0,18.99v-7.15H0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M13.88,0H3.12c-.55,0-1,.45-1,1v10.84h15.76v-7.84l-2.66-1.35-1.34-2.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.88,3c0,.55.45,1,1,1h3L13.88,0v3Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M12.15,8.06l-3.24-1.87c-.34-.19-.75.05-.75.44v3.74c0,.39.42.63.75.44l3.24-1.87c.34-.19.34-.68,0-.87Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M10,4.04c2.46,0,4.47,2,4.47,4.46s-2,4.47-4.47,4.47-4.47-2-4.47-4.47,2-4.46,4.47-4.46M10,3.2c-2.93,0-5.3,2.37-5.3,5.3s2.37,5.3,5.3,5.3,5.3-2.37,5.3-5.3-2.37-5.3-5.3-5.3h0Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.2,14.03l-1.58,3.79h-.84l-1.58-3.79h.91l1.11,2.71,1.13-2.71h.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.5,14.03h.85v3.79h-.85v-3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.21,14.03h1.66c1.2,0,2.02.75,2.02,1.89s-.82,1.89-2.02,1.89h-1.66v-3.79ZM8.83,17.1c.73,0,1.2-.45,1.2-1.17s-.48-1.17-1.2-1.17h-.77v2.35h.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.36,17.11v.7h-2.83v-3.79h2.76v.7h-1.92v.82h1.7v.68h-1.7v.88h1.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.79,15.92c0-1.13.85-1.96,2-1.96s2,.83,2,1.96-.85,1.96-2,1.96-2-.83-2-1.96ZM17.94,15.92c0-.72-.49-1.21-1.14-1.21s-1.14.49-1.14,1.21.49,1.21,1.14,1.21,1.14-.49,1.14-1.21Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoImg);
export default __webpack_public_path__ + "static/media/videoImg.cd46c0be9c8e53527c570cbbf1b5352e.svg";
export { ForwardRef as ReactComponent };